/* Vitaluxe redesign behaviours (3 Oct 2026): scroll reveal, carousels, mobile menu, product stock badge. */
(function () {
  var d = document, root = d.documentElement;
  root.classList.add('vl-js');
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    // reveal on scroll
    var els = [].slice.call(d.querySelectorAll('.vl-reveal'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('is-in'); }); }
    // carousels
    [].forEach.call(d.querySelectorAll('[data-vl-carousel]'), function (c) {
      var t = c.querySelector('[data-vl-track]'), dots = c.querySelector('[data-vl-dots]');
      if (!t) return;
      var cards = t.children;
      function step() { return cards[0] ? cards[0].getBoundingClientRect().width + 26 : 300; }
      var p = c.querySelector('[data-vl-prev]'), n = c.querySelector('[data-vl-next]');
      p && p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
      n && n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (dots) {
        for (var i = 0; i < cards.length; i++) {
          (function (i) {
            var b = d.createElement('button'); b.type = 'button'; b.tabIndex = -1;
            b.addEventListener('click', function () { t.scrollTo({ left: cards[i].offsetLeft - t.offsetLeft, behavior: 'smooth' }); });
            dots.appendChild(b);
          })(i);
        }
        var sync = function () {
          var idx = Math.round(t.scrollLeft / step());
          if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) idx = cards.length - 1;
          [].forEach.call(dots.children, function (b, j) { b.classList.toggle('is-on', j === idx); });
        };
        t.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
        sync();
      }
    });
    // mobile menu close
    [].forEach.call(d.querySelectorAll('[data-vl-mnav-close]'), function (b) {
      b.addEventListener('click', function () { var m = b.closest('details'); if (m) m.removeAttribute('open'); });
    });
    // product page stock badge follows the selected variant
    var badge = d.querySelector('[data-vl-stock]'), mapEl = d.querySelector('[data-vl-stock-map]');
    if (badge && mapEl) {
      var map = {}; try { map = JSON.parse(mapEl.textContent); } catch (e) {}
      var labels = { 'in': 'In stock', 'low': 'Low stock', 'out': 'Sold out' }, last = null;
      var upd = function () {
        var f = d.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = f && f.value; if (!id || id === last || !map[id]) return; last = id;
        badge.className = 'vl-stock vl-stock--' + map[id] + ' vl-stock--pdp';
        badge.querySelector('[data-vl-stock-label]').textContent = labels[map[id]];
      };
      d.addEventListener('change', function () { setTimeout(upd, 60); }, true);
      d.addEventListener('click', function () { setTimeout(upd, 120); }, true);
      upd();
    }
  });
})();

/* 4 Oct 2026: keep the lowercase 's' in 'COAs' inside uppercase labels, without a letter-spaced gap */
(function(){function fix(root){var w=document.createTreeWalker(root||document.body,NodeFilter.SHOW_TEXT),n,todo=[];
while(n=w.nextNode()){if(n.nodeValue.indexOf('COAs')<0||!n.parentElement||n.parentElement.closest('script,style,.vl-lcs'))continue;
 var cs=getComputedStyle(n.parentElement);if(cs.textTransform==='uppercase')todo.push([n,parseFloat(cs.letterSpacing)||0]);}
todo.forEach(function(x){var n=x[0],parts=n.nodeValue.split('COAs'),f=document.createDocumentFragment();
 parts.forEach(function(p,i){f.appendChild(document.createTextNode(p));if(i<parts.length-1){var g=document.createElement('span');g.className='vl-coas';g.appendChild(document.createTextNode('COA'));
  var s=document.createElement('span');s.className='vl-lcs';s.textContent='s';g.appendChild(s);f.appendChild(g);}});
 n.parentNode.replaceChild(f,n);});}
if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',function(){fix();});})();

/* 4 Oct 2026: research-use confirmation gates checkout (cart page + drawer); saved as cart attribute ruo_confirmed.
   19 Oct 2026: buttons stay clickable; while unticked a teal hint is shown, and a click/submit is blocked, the hint pulses and the box is highlighted. */
(function(){
  var SEL='button[name="checkout"],input[name="checkout"]';
  function sync(){document.querySelectorAll('[data-vl-ruo-wrap]').forEach(function(w){
    var cb=w.querySelector('[data-vl-ruo]'),box=w.parentElement,on=!!(cb&&cb.checked);
    box.querySelectorAll(SEL).forEach(function(b){if(b.dataset.vlRuoDis){b.disabled=false;delete b.dataset.vlRuoDis;}b.removeAttribute('aria-disabled');b.classList.toggle('vl-ruo-pending',!on);});
    box.querySelectorAll('.additional-checkout-buttons').forEach(function(a){a.classList.toggle('vl-ruo-off',!on);});
    box.querySelectorAll('[data-vl-ruo-hint]').forEach(function(h){h.hidden=on;if(on)h.classList.remove('is-warn');});
    if(on)w.classList.remove('is-warn');
  });}
  function warn(cb){var w=cb.closest('[data-vl-ruo-wrap]'),box=w.parentElement,h=box.querySelector('[data-vl-ruo-hint]');
    w.classList.remove('is-warn');void w.offsetWidth;w.classList.add('is-warn');
    if(h){h.hidden=false;h.classList.remove('is-warn');void h.offsetWidth;h.classList.add('is-warn');}
    try{w.scrollIntoView({block:'center',behavior:'smooth'});}catch(e){}cb.focus({preventScroll:true});}
  function boxCb(el){var box=el.closest('.m-cart__checkout, form, [class*="cart-drawer"], .m-cart-drawer')||document;var cb=box.querySelector('[data-vl-ruo]');
    if(!cb&&el.form){cb=document.querySelector('[data-vl-ruo][form="'+el.form.id+'"]')||el.form.querySelector('[data-vl-ruo]');}return cb;}
  document.addEventListener('change',function(e){var cb=e.target.closest&&e.target.closest('[data-vl-ruo]');if(!cb)return;
    document.querySelectorAll('[data-vl-ruo]').forEach(function(o){o.checked=cb.checked;});sync();
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{ruo_confirmed:cb.checked?'yes':''}})});});
  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest(SEL+',.additional-checkout-buttons');if(!b)return;
    var cb=boxCb(b);if(cb&&!cb.checked){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();warn(cb);}},true);
  document.addEventListener('submit',function(e){var s=e.submitter;if(!s||!s.matches||!s.matches(SEL))return;var cb=boxCb(s);
    if(cb&&!cb.checked){e.preventDefault();e.stopImmediatePropagation();warn(cb);}},true);
  var q=0;new MutationObserver(function(){if(q)return;q=1;requestAnimationFrame(function(){q=0;sync();});}).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState!=='loading')sync();else document.addEventListener('DOMContentLoaded',sync);
})();

/* 19 Oct 2026: add-to-basket feedback safety net. The theme opens the drawer after /cart/add returns; if that didn't happen
   (drawer missing, JS error, slow app script), open it here, else show an 'Added to basket' bar linking to /cart. */
(function(){
  function drawer(){return document.querySelector('m-cart-drawer');}
  function isOpen(){var d=drawer();return !!(d&&d.classList.contains('m-cart-drawer--active'));}
  function toast(){var n=document.querySelector('.vl-added');if(n)n.remove();n=document.createElement('div');n.className='vl-added';n.setAttribute('role','status');
    n.innerHTML='<span>Added to basket</span><a href="'+((window.MinimogSettings&&MinimogSettings.routes&&MinimogSettings.routes.cart)||'/cart')+'">View basket</a>';
    document.body.appendChild(n);setTimeout(function(){n.remove();},5000);}
  function feedback(){setTimeout(function(){if(isOpen())return;var d=drawer();
    if(d&&typeof d.open==='function'&&window.MinimogSettings&&MinimogSettings.enable_cart_drawer&&MinimogSettings.templateName!=='cart'){
      try{document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));}catch(e){}
      setTimeout(function(){if(!isOpen()){try{d.open();}catch(e){toast();}}},900);}
    else toast();},600);}
  var of=window.fetch;if(!of||of.__vlAtc)return;
  var nf=function(u,o){var p=of.apply(this,arguments);try{var s=typeof u==='string'?u:(u&&u.url)||'';
    if(/\/cart\/add(\.js)?(\?|$)/.test(s)&&!/vl-stack/.test(s))p.then(function(r){if(r&&r.ok)feedback();}).catch(function(){});}catch(e){}return p;};
  nf.__vlAtc=1;window.fetch=nf;
})();
